/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BattleHistory.css';
import ReactEcharts from 'echarts-for-react'
import moment from 'moment'


// console.log(ReactEcharts)

const list=[
  // '总值',
  // '微信',
  // '微博',
  // '知乎',
  // '今日头条'


  {
    class:'总值',
    type:'all'
  },{
    class:'微信',
    type:'wx'
  },{
    class:'微博',
    type:'wb'
  },{
    class:'知乎',
    type:'zh'
  },{
    class:'今日头条',
    type:'tt'
  }
]




class BattleHistory extends React.Component {

  constructor(props){
    super(props)
    this.state={
      active:'all'
    }
    this.getOption=this.getOption.bind(this)
  }


  getOption = () => {
    
    let data1 = [].concat(this.props.json[0])
    let data2 = [].concat(this.props.json[1])
    let data3 = [].concat(this.props.json[2])
    let data4 = [].concat(this.props.json[3])
    let data5 = [].concat(this.props.json[4])

    // for(var i=0;i<30;i++){ data5.push(data1[i]+data2[i]+data3[i]+data4[i]) }

    let propsData=this.props.json||[
      {
        name:'腾讯',
        all:[200,300,400,500],
        wx:[100,200,200,100],
        wb:[100,200,400,300],
        zh:[100,200,300,400],
        tt:[100,299,394,111]
      },{
        name:'阿里巴巴',
        all:[400,500,300,700],
        wx:[199,399,199,222],
        wb:[145,244,155,166],
        zh:[555,111,333,555],
        tt:[100,133,155,144]
      }
    ]

    let legendArr=[]

    propsData.forEach((i)=>
      legendArr.push(i.name)
    )




    const timeArr = []

    const m = (this.props.time.substring(5, 7)) - 1
    const d = Number(this.props.time.substring(8, 10)) + 1
    let time = moment().set({'month': m, 'date': d})
    for (var i = 0; i < 30; i++) {
      timeArr.unshift(time.subtract(1, 'days').format('MM-DD'))
      // timeArr.push(i)
    }

    // console.log(timeArr) console.log(data5,data1,data2,data3,data4)

    const option = {
      title: {
        text: `历史曲线图 - ${legendArr.join(' vs ')}`,
        subtext: '数据来源：数字品牌榜',
        // sublink:'',
        x: '20'
      },
      color:['#ffd70d','#608f9f','#014d67','#56b5a0','#248e76'],
      
      legend: {
        data: legendArr,
        right: 10,
        bottom: 10,
        orient: 'vertical',
      },
      toolbox: {
        show: true,
        feature: {
            restore: {},
            saveAsImage: {}
        },
        right: 20
    },
    grid: {
      left: '3%',
      right: '15%',
      bottom: '3%',
      containLabel: true
  },
      
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: {
        data: timeArr,
        type: 'category',
        silent: false,
        splitLine: {
          show: false
        }
      },
      yAxis: [
        {
          type: 'value',
          boundaryGap: [0.2, 0.2]
        }

      ],
      series: [
        {
          name: '微信',
          type: 'line',
          stack: '总值',
          data: data1,
          animationDelay: function (idx) {
            return idx * 10;
          }
        }, {
          name: '微博',
          type: 'line',
          stack: '总值',
          data: data2,
          animationDelay: function (idx) {
            return idx * 10 + 100;
          }
        }, {
          name: '知乎',
          type: 'line',
          stack: '总值',
          data: data3,
          animationDelay: function (idx) {
            return idx * 10 + 100;
          }
        }, {
          name: '今日头条',
          type: 'line',
          stack: '总值',
          data: data4,
          animationDelay: function (idx) {
            return idx * 10 + 100;
          }
        }
      ],
      series:propsData.map((i)=>{
        return{
          name:i.name,
          data:i[this.state.active],
          type:'line',
        }
      
      }),
      animationEasing: 'elasticOut',
      animationDelayUpdate: function (idx) {
        return idx * 5;
      }
    };
    return option
  }

  render() {
    return (
    
      <div className={s.root}>
          
          <select 
            onChange={(e)=>this.setState({active:e.target.value})}
            value={this.state.active}
            className={s.selectLayout}
          >
            {list.map((i)=>{
              return(
                <option value={i.type} key={i.type}>{i.class}</option>
              )
            })}
          </select>
          
        <ReactEcharts
          option={this.getOption()}
          style={{
          height: '550px',
          width:'100%',
          
          borderRadius: '4px'
          }}
          className={s.charts}
          notMerge={true}
          lazyUpdate={true}
          theme={"theme_name"}
          onChartReady={this.onChartReadyCallback}/>
      </div>
          
    
    )


   
  }
}

export default withStyles(s)(BattleHistory);



// WEBPACK FOOTER //
// src/components/BattleHistory/BattleHistory.js